import React from 'react'
import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import PriceRowPriceWithCaption from 'LuxKit/PricePoints/PriceRowPriceWithCaption'
import PriceRowValueDiscount from 'LuxKit/PricePoints/Value/PriceRowValueDiscount'
import PriceRowCaption from 'LuxKit/PricePoints/PriceRowCaption'
import CruiseLoyaltyPoints from 'components/Cruises/CruiseLoyaltyPoints'

export interface PriceRoomTypeProps {
  offer?: App.CruiseOffer
  priceFrom: App.CruisePriceDetails
  header?: boolean
  hasValidDepartures?: boolean
}

function CruisePriceRoomTypeInfo({ priceFrom, hasValidDepartures, offer, header = false }: PriceRoomTypeProps): React.ReactElement {
  const intl = useIntl()

  const fromCaption = intl.formatMessage({
    id: 'lZ+S/ZGKEP',
    defaultMessage: 'From',
    description: 'Price caption indicating starting price for cruise offer',
  })

  const perPersonUnit = intl.formatMessage({
    id: 'n70SzsTaKr',
    defaultMessage: 'person',
    description: 'Price unit for per-person cruise pricing in sticky header',
  })

  return (
    <>
      <Group direction="vertical" gap={4}>
        {!!offer && <CruiseLoyaltyPoints offer={offer} calculationType="estimate" />}

        {hasValidDepartures && <div>
          <PriceRowPriceWithCaption
            size="S"
            caption={fromCaption}
            price={priceFrom.total}
            saleUnit={perPersonUnit}
          />
          <PriceRowCaption>
            {intl.formatMessage({
              id: 'mHfn5U73WK',
              defaultMessage: 'Twin share',
              description: 'Price caption indicating twin share room type in the cruises section',
            })}
          </PriceRowCaption>

          {!header && priceFrom.discountPills?.discountPercentage && <PriceRowValueDiscount
            type="estimate"
            discountPercentage={priceFrom.discountPills.discountPercentage}
          />}
        </div>}
      </Group>

      {!hasValidDepartures && <Group direction="vertical" verticalAlign="center" fullWidth>
        <BodyText variant="large" weight="bold" align="center">
          {intl.formatMessage({
            id: 'hZqiWh9QZk',
            defaultMessage: 'This offer has sold out',
            description: 'Message displayed when cruise offer has no available departures',
          })}
        </BodyText>
      </Group>}
    </>
  )
}

export default CruisePriceRoomTypeInfo
